export class MainNavBarEnum {
  static DASHBOARD = "dashboard";
  static SEARCH_CLIENTS = "search-clients";
  static ADD_CLIENT = "add-client";
  static PROVIDER_MAP = "provider-map";
  static APPOINTMENT_CALENDAR = "appointment-calendar";
  static ANALYTICS = "analytics";
  static CLIENT_DETAIL = "client-detail";
  static REPORTS = "reports";
  static USER_MANAGER = "user-manager";
}